const initialState = {
  adminList:[],
  adminPage:1,
  adminSize:10,
  adminTotal:0,
  adminById:{},
  adminModalType:"create",
  adminModalVisible:false,
  currentAdmin:{},
  getAdminListPending: false,
  getAdminListError: null,
  submitAdminPending: false,
  submitAdminError: null,
  deleteAdminPending: false,
  deleteAdminError: null,
  deptList:[],
  deptPage:1,
  deptSize:10,
  deptTotal:0,
  deptById:{},
  deptModalType:"create",
  deptModalVisible:false,
  currentDept:{},
  getDeptListPending: false,
  getDeptListError: null,
  submitDeptPending: false,
  submitDeptError: null,
  deleteDeptPending: false,
  deleteDeptError: null,
  getAllDeptPending: false,
  getAllDeptError: null,
  deptTree:[],
  allDeptById:{},
  dicnameList:[],
  dicnamePage:1,
  dicnameSize:10,
  dicnameTotal:0,
  dicnameById:{},
  dicnameModalType:"create",
  dicnameModalVisible:false,
  currentDicname:{},
  getDicnameListPending: false,
  getDicnameListError: null,
  submitDicnamePending: false,
  submitDicnameError: null,
  deleteDicnamePending: false,
  deleteDicnameError: null,
  dicvaluesList:[],
  dicvaluesPage:1,
  dicvaluesSize:10,
  dicvaluesTotal:0,
  dicvaluesById:{},
  dicvaluesModalType:"create",
  dicvaluesModalVisible:false,
  currentDicvalues:{},
  getDicvaluesListPending: false,
  getDicvaluesListError: null,
  submitDicvaluesPending: false,
  submitDicvaluesError: null,
  deleteDicvaluesPending: false,
  deleteDicvaluesError: null,
  getDicListPending: false,
  getDicListError: null,
  dicTypes:{},
  aconfigList:[],
  aconfigPage:1,
  aconfigSize:10,
  aconfigTotal:0,
  aconfigById:{},
  aconfigModalType:"create",
  aconfigModalVisible:false,
  currentAconfig:{},
  getAconfigListPending: false,
  getAconfigListError: null,
  submitAconfigPending: false,
  submitAconfigError: null,
  deleteAconfigPending: false,
  deleteAconfigError: null,
  resetPasswordPending: false,
  resetPasswordError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/admin/redux/initialState.js